import React, { useEffect, useRef, useState } from 'react';
import './_invitation.less';
import { Button, Card, Checkbox, Form } from 'antd';
import { ArrowRight, Check, Cross, CryptoLogo, FinanceLogo, UnifyLogo, Support, TimeNew, FinclubLogo } from 'IMAGE';
import axios from 'axios';
import api from 'API';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { fetchAllPersonalData } from '@features/personalSlice';
import { getUserToken } from '@features/userTokenSlice';
// import { getUserToken } from '@features/userTokenSlice';
// import { fetchAllPersonalData } from '@features/personalSlice';
// import { connect } from 'react-redux';
// import { withRouter } from 'react-router-dom';

const Invitation = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [rights, setRights] = useState(false);
  const [terms, setTerms] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const popupRef = useRef(null);
  const intervalRef = useRef(null);

  const history = useHistory();

  // Заменяем mapStateToProps
  const userToken = useSelector((state) => state.userToken);

  // Заменяем mapDispatchToProps
  const dispatch = useDispatch();

  const cards = [
    { id: 'payment', title: 'Payment', subtitle: 'MAGMA FINANCE', logo: <FinanceLogo /> },
    { id: 'investment', title: 'Investment', subtitle: 'UNIFY', logo: <UnifyLogo /> },
    { id: 'crypto', title: 'Crypto', subtitle: 'FINARIUM', logo: <CryptoLogo /> },
  ];

  const toggleCard = (id) => {
    setSelectedCards((prev) => (prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]));
  };

  // Функция для получения URL авторизации
  const getAuthUrl = async (space) => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await axios(api.users.authorization.loginByOauth(space).AXIOS('GET'));

      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.data.url;
    } catch (err) {
      setError(err.message);
      console.log(error);
      throw err;
    } finally {
      setIsLoading(false);
      console.log(isLoading);
    }
  };

  // Очистка интервала
  const clearPopupInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Закрытие popup
  const closePopup = () => {
    console.log('closePopup в closePopup');
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.close();
      popupRef.current = null;
    }
    clearPopupInterval();
  };

  const successCallback = async (tokenData) => {
    console.log(tokenData);
    const userType = tokenData?.user?.type;
    // this.props.history.push(`/${userType}`);
    dispatch(
      getUserToken({
        ...tokenData.access_token,
        tokenType: userType,
        isLogged: true,
      })
    );
    await dispatch(fetchAllPersonalData());
    history.push(`/${userType}`);
  };

  // Обработка успешной авторизации
  const handleOAuthSuccess = (tokenData) => {
    console.log('OAuth successful!', tokenData);

    if (successCallback) {
      successCallback(tokenData);
    } else {
      alert('Authentication successful! Token received.');
    }
  };

  // Эффект для обработки сообщений
  useEffect(() => {
    const messageHandler = (event) => {
      // В продакшене нужно проверять origin сообщения!
      // if (event.origin !== 'https://your-app.com') return;

      // console.log('Received message:', event.data);

      // Проверяем структуру данных
      if (event.data && event.data.user) {
        const tokenData = event.data;
        console.log('Received token data:', tokenData);

        console.log('closePopup');
        // Закрываем popup
        closePopup();

        // Обрабатываем полученные данные
        handleOAuthSuccess(tokenData);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      console.log('closePopup в return useEffect');
      window.removeEventListener('message', messageHandler);
      closePopup();
    };
  }, []);

  // Функция открытия popup окна
  const openAuthPopup = async (space) => {
    try {
      // Закрываем предыдущее popup окно, если оно есть
      // closePopup();

      // Получаем URL для авторизации
      const authUrl = await getAuthUrl(space);

      // Настройки popup окна
      const width = 600;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      console.log('Opening popup with URL:', authUrl);
      // debugger;
      // Открываем popup окно
      const newPopup = window.open(
        authUrl,
        'OAuth Authentication',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );

      if (!newPopup) {
        throw new Error('Popup blocked. Please allow popups for this site.');
      }

      console.log(popupRef);
      console.log(newPopup);

      popupRef.current = newPopup;
      // debugger;

      // Проверяем, закрылось ли popup (например, пользователь закрыл вручную)
      intervalRef.current = setInterval(() => {
        console.log(newPopup);
        if (newPopup.closed) {
          clearPopupInterval();
          popupRef.current = null;
          setError('Authentication was cancelled');
        }
      }, 1000);
    } catch (err) {
      setError(err.message);
    }
  };

  let cardChoose = 2;
  let card;
  if (cardChoose === 1) {
    card = (
      <div className='card'>
        <div className='icon-wrapper'>
          <div className='icon'>
            <TimeNew />
          </div>
        </div>

        <p className='title'>Invitation expired</p>

        <p className='description'>This invitation link has expired. Please request a new one.</p>

        <Button type='primary' className='btn'>
          REQUEST TO SUPPORT <Support />
        </Button>
      </div>
    );
  } else if (cardChoose === 2) {
    card = (
      <div className='card'>
        <div className='icon-wrapper'>
          <div className='icon'>
            <Check />
          </div>
        </div>

        <p className='title'>Invitation link</p>

        <p className='description'>Please log in to your account using Magma.</p>

        <Button type='primary' className='btn' onClick={() => openAuthPopup('magma')}>
          OAUTH MAGMA <ArrowRight />
        </Button>
      </div>
    );
  } else if (cardChoose === 3) {
    card = (
      <div className='card'>
        <div className='icon-wrapper'>
          <div className='icon'>
            <Cross />
          </div>
        </div>

        <p className='title'>Invalid invitation link</p>

        <p className='description'>The link you used is invalid. Please check the URL or request a new invite.</p>

        <div className='button-block'>
          <Button type='primary' className='btn'>
            REQUEST TO SUPPORT <Support />
          </Button>
          <Button type='primary' className='btn'>
            GO TO SIGN IN <ArrowRight />
          </Button>
        </div>
      </div>
    );
  } else if (cardChoose === 4) {
    card = (
      <div className='card'>
        <div className=''>
          <Form onSubmit={handleSubmit} className='select-space'>
            <div className='select-space__header'>
              <div className='select-space__title'>You’ve been invited to create your account</div>
            </div>
            <p className='select-space__subtitle'>To continue, please confirm your details and accept the terms.</p>

            <div className='select-items'>
              {cards.map((card) => {
                const selected = selectedCards.includes(card.id);
                return (
                  <Card
                    key={card.id}
                    className={`select-item ${selected ? 'selected' : ''}`}
                    onClick={() => toggleCard(card.id)}
                    bordered
                  >
                    <div className='select-item-inner'>
                      <Checkbox checked={selected} onChange={() => toggleCard(card.id)} />
                      <div className='select-item-text'>
                        <div className='select-item-title'>{card.title}</div>
                        <div className='select-item-subtitle'>{card.subtitle}</div>
                      </div>
                      <div className='icon-placeholder'>{card.logo}</div>
                    </div>
                  </Card>
                );
              })}
            </div>

            <div className='checkbox-block'>
              <Checkbox
                className='ant-checkbox-sm'
                checked={rights}
                onChange={(e) => setRights(e.target.checked)}
              ></Checkbox>
              <div className='text'>
                I confirm that I have all necessary rights and was specifically authorized by the company for the
                account opening in MAGMA Finance
              </div>
            </div>
            <div className='checkbox-block'>
              <Checkbox checked={terms} onChange={(e) => setTerms(e.target.checked)}></Checkbox>
              <div className='text'>
                I have read and agree to the <a href='#'>Terms & Conditions</a> and <a href='#'>Privacy Policy</a>
              </div>
            </div>
            <Button type='primary' htmlType='submit' className='continue-btn' block>
              <div className='continue-btn__content'>
                <span>CONTINUE</span> <ArrowRight />
              </div>
            </Button>
          </Form>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='invitation-page'>
        <header className='header-block'>
          <div className='logo'>
            <FinclubLogo />
          </div>
        </header>

        <main className='content'>{card}</main>

        <footer className='footer'>
          <div className='copy'>© 2025 Company Name. All rights reserved.</div>
          <div className='links'>
            <a href='#'>TERMS OF SERVICE</a>
            <span>|</span>
            <a href='#'>PRIVACY POLICY</a>
          </div>
          <div className='support'>
            <p className='label'>CONTACT SUPPORT:</p>
            <a href='mailto:support@example.com'>support@example.com</a>
          </div>
        </footer>
      </div>
    </>
  );
};

// const mapStateToProps = ({ userToken }) => {
//   return {
//     userToken: userToken,
//   };
// };
//
// const mapDispatchToProps = (dispatch) => {
//   return {
//     getUserToken: (value) => dispatch(getUserToken(value)),
//     fetchAllPersonalData: () => dispatch(fetchAllPersonalData()),
//   };
// };

export default Invitation;

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Invitation));
